<template>
  <el-dialog
    class="product-price-dialog"
    :visible="true"
    width="70%"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div slot="title">
      <div>Alapértelmezett árak</div>
    </div>
    <div v-loading="loading">
      <el-form>
        <table class="product-price-table">
          <thead class="product-price-table__header">
            <tr>
              <td style="width: 160px">Termék név</td>
              <td>Beszerzési ár</td>
              <td>Ár</td>
              <td>Padló ár</td>
              <td>Kisker ár</td>
              <td>Web ár</td>
            </tr>
          </thead>
          <tbody>
            <table-row
              v-for="product in productPrices"
              ref="row"
              :key="product.id"
              :product-price="product"
            />
          </tbody>
        </table>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        Mentés
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

  import TableRow from './DialogTableRow';

  export default {

    components: { TableRow },

    data() {
      return {
        loading: false,
        buttonLoading: false,
        productPrices: [],
      }
    },
    async mounted() {
     await this.loadProductPrices();
    },
    methods: {

      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/data/customer-price-lists');
        })
        .catch(() => {
        });
      },

      async store() {
        const productsToUpdate = [];
        let isAllValid = true;
        this.$refs.row.forEach(row => {
          if(!row.isAllPriceValid()) {
            isAllValid = false;
          }
          if(row.isChanged()) {
            productsToUpdate.push(row.product);
          }
        });
        if(isAllValid) {
          this.buttonLoading = true;
          try {
            await axios.post('api/products/product-prices', productsToUpdate);
            this.loadProductPrices();
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      },
      async loadProductPrices() {
        this.loading = true;
        this.productPrices = await axios.get('api/products/product-prices');
        this.loading = false;
      }
    },
  };
</script>
<style
  lang="scss">

  $borderColor: #EBEEF5;
  $headerColor: #909399;

  .product-price-table {
    border-left: 1px solid $borderColor;
    border-top: 1px solid $borderColor;
    width: 100%;

    .product-price-table__header {
      color: $headerColor;
      font-size: 14px;
      font-weight: bold;
      width: calc( 100% - 1em );
    }

    tbody {
      display: block;
      height: 400px;
      overflow: auto;
    }

    tr {
      display:table;
      width:100%;
      table-layout:fixed;

      td {
        border-right: 1px solid $borderColor;
        border-bottom: 1px solid $borderColor;
        padding: 12px 10px;
        margin-bottom: -1px;
        vertical-align: top;
      }
    }

  }

  /*.product-price-dialog {
    .el-dialog {
      .el-dialog__body {
        height: 400px;
        overflow: scroll;
      }

      .el-dialog__footer {
        position: sticky;
        background-color: #ffffff;
      }
    }
  }*/

</style>
